import type { DueResponse } from "../types";

/**
 * "3 of 9 done today" line + thin bar at the top of the Today Card, so a
 * farm hand sees the size of the day at a glance before heading out.
 *
 * Today's work = what's still owed (Overdue + Due today) plus what's
 * already been done today. "Whenever you get a chance" and the flexible
 * "This week" items are optional and don't count against the day until
 * someone actually does one (then it lands in `done_today` and counts on
 * both sides). Renders nothing on a day with no work at all.
 */
export function TodayProgress({
  data,
}: {
  data: Pick<DueResponse, "overdue" | "due_today" | "done_today">;
}) {
  const done = data.done_today.length;
  const total = done + data.overdue.length + data.due_today.length;
  if (total === 0) return null;

  const allDone = done === total;
  const label = allDone ? `All ${total} done today` : `${done} of ${total} done today`;

  return (
    <div class={`today-progress${allDone ? " all-done" : ""}`}>
      <p class="today-progress-label">{label}</p>
      <div class="today-progress-bar" aria-hidden="true">
        <div
          class="today-progress-fill"
          style={{ width: `${Math.round((done / total) * 100)}%` }}
        />
      </div>
    </div>
  );
}
